import * as React from 'react';
import { ButtonGroup, ButtonGroupItem } from '../../composites/ButtonGroup';

export interface CriteriaRuleGroupToolbarProps {
  semanticId: string;
  groupIndex: number;
  showDeleteGroup: boolean;
  onAddGroup: () => void;
  onDeleteGroup: () => void;
  onAddRule: () => void;
}

export function CriteriaRuleGroupToolbar({
  semanticId,
  groupIndex,
  showDeleteGroup,
  onAddGroup,
  onDeleteGroup,
  onAddRule,
}: CriteriaRuleGroupToolbarProps) {
  return (
    <ButtonGroup compact semanticId={`${semanticId}BtnGroup.${groupIndex}`}>
      <ButtonGroupItem
        variant='secondary-white'
        icon='add_circle_outline'
        label='Add Group'
        semanticId={`${semanticId}AddGroup.${groupIndex}`}
        onClick={onAddGroup}
      />
      {showDeleteGroup ? (
        <ButtonGroupItem
          variant='secondary-red'
          icon='remove_circle_outline'
          label='Delete Group'
          semanticId={`${semanticId}DeleteGroup.${groupIndex}`}
          onClick={onDeleteGroup}
        />
      ) : null}
      <ButtonGroupItem
        variant='secondary-white'
        icon='add_circle_outline'
        label='Add Rule'
        semanticId={`${semanticId}AddRule.${groupIndex}`}
        onClick={onAddRule}
      />
    </ButtonGroup>
  );
}

CriteriaRuleGroupToolbar.displayName = 'CriteriaRuleGroupToolbar';
